module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-1_FR-4ce36798a42bdf576f5828922d1953a2.svg";